// ADDED: Salary Advance Deduction Bracket Service
import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const salaryAdvanceDeductionBracketService = {
  getAll: async () => {
    return await axios.get(`${domain}/api/SalaryAdvanceDeductionBracket`, { headers });
  },

  getDeductionAmountByCutoffCount: async (params) => {
    try {
      const res = await axios.get(`${domain}/api/SalaryAdvanceDeductionBracket/loan-deduction-amount`, {
        headers,
        params: params
      });
      return res.data;
    } catch (err) {
      console.error(err);
    }
  },

  getById: async (id) => {
    return await axios.get(`${domain}/api/SalaryAdvanceDeductionBracket/${id}`, { headers });
  },

  create: async (payload) => {
    return await axios.post(`${domain}/api/SalaryAdvanceDeductionBracket`, payload, { headers });
  },

  update: async (id, payload) => {
    return await axios.put(`${domain}/api/SalaryAdvanceDeductionBracket/${id}`, payload, { headers });
  },

  delete: async (id) => {
    return await axios.delete(`${domain}/api/SalaryAdvanceDeductionBracket/${id}`, { headers });
  },
};

export default salaryAdvanceDeductionBracketService;